import CatSubGradeDropdown from '@/components/cat-sub-grade-drpdn/cat-sub-grade-drpdn';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'min-score-completion-form',
    components: {
        'cat-sub-grade-drpdn': CatSubGradeDropdown,
    },
})

export default class MinScoreCompletionForm extends Vue {

    // --------------------------------------------------------------------
    // Properties

    @Prop({ default: {} })
    private value: any;

    @Prop()
    private isReadOnly: any;

    @Prop()
    private categorySubjectData: any;

    private updateValue: any;

    private minScore: any;

    private content: any = {};

    private isWithGrades: any = false;

    private isWithFw: any = true;

    private categoryList: any = [];

    private dataPropsValues: any = [];

    private dataStringValue: any = '';

    private isExpand: boolean = false;

    private indexNumber: number = 5;

    private isLoading: boolean = false;

    private selectedRecentItem: any = {};

    private subjectAndFwList: any = [];

    private cateogryOptions: any = [];

    @Watch('categorySubjectData')
    private onWatchData(data: any) {
        if (data && data.length > 0) {
            this.fetchDisplayPropParent();
        }
    }

    // ---------------------------------------------------------------------
    // Methods


    // -------------------------------------------------------------------
    // Hooks

    private created() {
        this.content = this.value;
        if (this.isReadOnly) {
            // this.fetchDisplayProp();
        } else {
            // { "CCSS.K12.MA": 80 }
            this.fetchCategoryList();
            // for (const key in this.content) {
            //     if (this.content.hasOwnProperty(key)) {
            //         this.minScore = this.content[key];
            //     }
            // }
        }
    }

    private mounted() {
        if (this.categorySubjectData && this.categorySubjectData.length > 0) {
            this.fetchDisplayPropParent();
        }
    }

    // ---------------------------------------------------------------------
    // Actions

    private updateCatSub(value: any) {
        this.updateValue = value;
        this.onUpdate();
    }

    private updateScore(value: any) {
        this.minScore = value;
        this.onUpdate();
    }

    private onUpdate() {
        if (!this.isWithGrades && this.isWithFw) {
            if (this.updateValue && this.updateValue.frameworks && this.updateValue.frameworks.selectedItems) {
                this.$emit('input', { [this.updateValue.frameworks.selectedItems]: this.minScore });
            }
        }
    }

    private async fetchDisplayPropParent() {
        const categoryList = this.categorySubjectData;
        // const valueData: any = { "CCSS.K12.MA": 80, "TNM.K12.MA": 75, "SC.HE.CS":60, "GDF.HE.BS":50 };
        const valueData: any = this.content;
        const dataValuesCalculate: any = [];
        for (const prop in valueData) {
            if (valueData.hasOwnProperty(prop)) {
                const propSplit = prop.split('.');
                const data: any = {
                    keyName: prop,
                    keyValue: valueData[prop],
                    categoryId: propSplit[1],
                    subjectId: `${propSplit[1]}.${propSplit[2]}`,
                    frameworkId: propSplit[0],
                };
                dataValuesCalculate.push(data);
            }
        }
        for await (const [index, iterator] of dataValuesCalculate.entries()) {
            const selectedCategoryIndex = categoryList.findIndex((catItem: any) => {
                return catItem.code === iterator.categoryId;
            });
            if (selectedCategoryIndex !== -1) {
                const selectedSubjectIndex = categoryList[selectedCategoryIndex].subjectList.findIndex((item: any) => {
                    return item.id === iterator.subjectId;
                });
                const selectedSubject = categoryList[selectedCategoryIndex].subjectList[selectedSubjectIndex];
                iterator.subjectTitle = selectedSubject.title;
            }
        }
        this.dataPropsValues = dataValuesCalculate;
    }

    private getSubjectList(categoryId: string) {
        return taxonomyAPI.fetchSubjects(categoryId).then((subjectList: any) => {
            return subjectList;
        });
    }

    private showMore() {
        this.indexNumber = this.indexNumber + 5;
        this.$emit('showMore');
    }

    private adjustHeight() {
        this.$emit('showMore');
    }

    private fetchCategoryList() {
        const valueData: any = this.content;
        const dataValuesCalculate: any = [];
        for (const prop in valueData) {
            if (valueData.hasOwnProperty(prop)) {
                const propSplit = prop.split('.');
                const data: any = {
                    keyName: prop,
                    keyValue: valueData[prop],
                    categoryId: propSplit[1],
                    subjectId: `${propSplit[1]}.${propSplit[2]}`,
                    frameworkId: propSplit[0],
                };
                dataValuesCalculate.push(data);
            }
        }
        this.isLoading = true;
        taxonomyAPI.fetchTaxonomyClassifications().then(async (categoryList: any) => {
            for await (const [index, iterator] of categoryList.entries()) {
                const catIndex = dataValuesCalculate.findIndex((item: any) => {
                    return item.categoryId === iterator.code;
                });
                const subjectList = await taxonomyAPI.fetchSubjects(iterator.id);
                if (catIndex !== -1) {
                    iterator.preSelect = true;
                    subjectList.filter((subject: any) => dataValuesCalculate.
                        findIndex((dataValue: any) => dataValue.subjectId === subject.id) >= 0)
                        .forEach((selectedNewSubject: any) => {
                            selectedNewSubject.preSelect = true;
                            selectedNewSubject.frameworks.filter((fw: any) => dataValuesCalculate.
                                findIndex((dataValue: any) => dataValue.keyName === fw.taxonomy_subject_id) >= 0)
                                .forEach((selectedNewFW: any) => {
                                    selectedNewFW.value = valueData[selectedNewFW.taxonomy_subject_id];
                                });
                        });
                }
                iterator.subjects = subjectList;
                if (index >= categoryList.length - 1) {
                    this.isLoading = false;
                    this.selectedRecentItem = categoryList[0];
                    this.subjectAndFwList = this.selectedRecentItem.subjects;
                    this.cateogryOptions = categoryList;
                }
            }
        });
    }

    private selectCategroy(item: any) {
        this.selectedRecentItem = item;
        this.subjectAndFwList = item.subjects;
    }

    private onUpdateFw(itemFw: any) {
        const item = itemFw.taxonomy_subject_id;
        itemFw.value = typeof (itemFw.value) === 'string' ? parseInt(itemFw.value, 10) : itemFw.value;
        this.value[item] = itemFw.value;
        this.$emit('input', this.value);
    }
}
